import DialogPlayer from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/engine/player/DialogPlayer";
import DialogPlayerEvent from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/engine/player/DialogPlayerEvent";


import Event from "../../../../../../lib/html5-software-library/src/ranj/util/Event";
import EventDispatcher from "../../../../../../lib/html5-software-library/src/ranj/util/EventDispatcher";
import { isNull } from "../../../../../../lib/html5-software-library/src/ranj/util/TypeUtil";
import { DialogOption, DialogState, DialogTransition } from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/engine/model/Dialog";
import KeyDecisionContentEvent from "../../../key-decisions/event/KeyDecisionContentEvent";
import AppDialogPlayerEvent from "./AppDialogPlayerEvent";
import KeyMomentChoiceContent from "../../../../../../lib/html5-software-library/src/ranj/eng/content/KeyMomentChoiceContent";

export default class AppDialogPlayer extends DialogPlayer {
    constructor(timeTickInterval) {
        super(timeTickInterval);
    }

    next() {
        if (this.currentDialog === null)
            return;

        switch (this.position.level)
        {
            case Position.START:
                this.enterDialog();
                break;

            case Position.DIALOG:
                if (isNull(this.position.nextCommandSequence))
                {
                    this.exitDialog();
                }
                else
                {
                    this.enterCommandSequence(this.position.nextCommandSequence);
                }
                break;

            case Position.COMMAND_SEQUENCE:
                if (this.position.commandsIterator.hasNext())
                {
                    const currentCommand = this.position.commandsIterator.next();
                    if ((!currentCommand.isExecuteOnce() || !this.isExecuted(currentCommand)) && (currentCommand.getCondition() === null || currentCommand.getCondition().solve(this.conditionSolver)))
                    {
                        this.processCommand(currentCommand);
                    }
                    else
                    {
                        // When a KeyMomentChoiceContent is ignored, we trigger a AppDialogPlayerEvent.SKIP_DIALOG_OPTION
                        // Ignored Key Decisions answers that have a good rating will then further down the line be saved
                        let content = currentCommand.getData().getData().content;
                        if (content instanceof KeyMomentChoiceContent) {
                            this.dispatchEvent(AppDialogPlayerEvent.SKIP_DIALOG_OPTION, content, this);
                        }
                        this.next();
                    }
                }
                else
                {
                    this.eventQueue.push(new Event(DialogPlayerEvent.COMMAND_SEQUENCE_END));
                    if (this.position.currentCommandSequence instanceof DialogTransition)
                    {
                        this.exitCommandSequence(this.position.currentCommandSequence.getState());
                    }
                    else if (this.numCurrentOptions === 0)
                    {
                        this.exitCommandSequence();
                    }
                }
                break;

            case Position.END:
                break;
        }
    }
}

// ---------------- Inner class Position ------------------------------

class Position {
    constructor() {
        this.level = Position.START;
        this.currentCommandSequence = null;
        this.commandsIterator = null;
        this.nextCommandSequence = null;
    }
    clone() {
        var clone = new Position();
        clone.level = this.level;
        clone.currentCommandSequence = this.currentCommandSequence;
        clone.commandsIterator = this.commandsIterator;
        clone.nextCommandSequence = this.nextCommandSequence;

        return clone;
    }
    destroy() {
        this.reset();
    }
    reset() {
        this.level = Position.START;
        this.currentCommandSequence = null;
        this.commandsIterator = null;
        this.nextCommandSequence = null;
    }
}

Position.START = 0;
Position.DIALOG = 1;
Position.COMMAND_SEQUENCE = 2;
Position.END = 3;